// extracted by mini-css-extract-plugin
export const animating = "HorizontalSlider__animating__R-XLc";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const horizontalSlider = "HorizontalSlider__horizontalSlider__3Dqoc";
export const medium = "500";
export const other = "HorizontalSlider__other__9BJLT";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const slide = "HorizontalSlider__slide__ACosI";